import XLSX from 'js-xlsx'
import FileSaver from 'file-saver'

function Workbook () {
  if (!(this instanceof Workbook)) return new Workbook()
  this.SheetNames = []
  this.Sheets = {}
}

export default {
  export (Name, Columns, Data, WbName = '') {
    return new Promise((resolve, reject) => {
      try {
        let { wb, ws } = this.createWB(WbName || Name)
        // main
        ws['!ref'] = XLSX.utils.encode_range({
          s: { c: 0, r: 0 },
          e: { c: Columns.length - 1, r: Data.length }
        })
        // header
        Columns.forEach((column, index) => {
          const width = column.width || (column.title ? String(column.title).length : undefined)
          ws['!cols'].push({ wch: width })
          ws[XLSX.utils.encode_cell({ c: index, r: 0 })] = {
            wch: width,
            v: column.title,
            t: 's',
            s: { alignment: { horizontal: 'center' }, font: { bold: true } }
          }
        })
        // rows
        Data.forEach((data, rowIndex) => {
          Columns.forEach((column, colIndex) => {
            let type = column.type || 's'
            let value = data[column.field] || ''
            if (typeof column.template === 'function') value = column.template(data)
            if (value) {
              switch (type) {
                case 's':
                  value = String(value)
                  break
                case 'd':
                  value = new Date(value)
                  break
                case 'b':
                  value = Boolean(value)
                  break
              }
            }
            ws[XLSX.utils.encode_cell({ c: colIndex, r: rowIndex + 1 })] = {
              v: value,
              t: type,
              s: column.style
            }
          })
        })
        // create dara rows
        this.generateAndSave(wb, Name)
        resolve('done')
      } catch (e) {
        throw new Error(e)
      }
    })
  },
  createWB (Name) {
    let wb = new Workbook()
    wb.SheetNames.push(Name)
    wb.Sheets[Name] = { '!cols': [] }
    let ws = wb.Sheets[Name]
    return { wb: wb, ws: ws }
  },
  s2ab (s) {
    if (typeof ArrayBuffer !== 'undefined') {
      let buf = new ArrayBuffer(s.length)
      let view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF

      return buf
    } else {
      let buf = new Array(s.length)
      for (let i = 0; i !== s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF
      return buf
    }
  },
  generateAndSave (wb, wsName) {
    /* generate X file */
    const wbout = XLSX.write(wb, { type: 'binary', bookType: 'xlsx', bookSST: true })
    /* send to client */
    FileSaver.saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), `${wsName}.xlsx`)
  }

}
